import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SplashService {
  private showSplashSubject = new BehaviorSubject<boolean>(true);
  showSplash$ = this.showSplashSubject.asObservable();

  constructor() {
    setTimeout(() => {
      this.showSplashSubject.next(false);
    }, 6000);
  }
}
